angular.module('app').factory('paymentsService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer) {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var payments = restAngular.all("/payments/");

        return {
            getList: function (requestData) {
                return payments.one("get").customGET(param(requestData))
            },
            saveData: function (requestData) {
                return payments.one("apiSwitchPayments").post("", requestData)
            },
            changeState: function (requestData) {
                return payments.one("changeState").post("", requestData)
            }
        }
    }
]);